import { NgModule, Optional, SkipSelf } from '@angular/core';
import { TenantService } from './services/tenant.service';
import { ThemeService } from './services/theme.service';
import { FeatureFlagService } from './services/feature-flag.service';
import { FeatureGuard } from './guards/feature.guard';

@NgModule({
  providers: [
    TenantService,
    ThemeService,
    FeatureFlagService,
    FeatureGuard,
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in AppModule only.');
    }
  }
}
